import { render } from "./BannerDefaultPostSectionCmp.vue?vue&type=template&id=bf7fc196"
import script from "./BannerDefaultPostSectionCmp.vue?vue&type=script&lang=js"
export * from "./BannerDefaultPostSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__